import type { TypographyVariant } from '@mui/material/styles';

export type Size = 'small' | 'medium' | 'large';

const textMapping: Readonly<Record<Size, TypographyVariant>> = {
  small: 'caption',
  medium: 'body2',
  large: 'body1',
};

export const mapTextSize = (size?: Size): TypographyVariant | 'inherit' =>
  size ? textMapping[size] : 'inherit';
